import { render } from "./DetailProgres.vue?vue&type=template&id=dc8d2b26"
import script from "./DetailProgres.vue?vue&type=script&lang=js"
export * from "./DetailProgres.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__